export const ERROR_ACCOUNT_NOT_EXIST = 2000;
export const ERROR_EMAIL_EXPIRED = 5007;
export const ERROR_GROUP_BUYING_OVER = 17002;
export const ERROR_NOT_IN_GROUP_BUYING = 17010;
export const ERROR_ORDER_CANCELED = 22006;
export const ERROR_ORDER_HAS_BEEN_TOKEN = 22007;
export const ERROR_ORDER_NOT_FOUND = 22008;
export const ERROR_ORDER_OVER_AMOUNT_LIMIT = 22003;
export const ERROR_ORDER_OVER_ITEM_LIMIT = 22004;
export const ERROR_ORDER_OVER_LIMIT = 17008;
export const ERROR_PARAM = 400;
export const ERROR_RECEIVE_TIME_ID = 22015;
export const ERROR_RECORD_NOT_FOUND = 1001;
export const ERROR_TOKEN_EXPIRED = 7003;

export default {};
